import { schema } from 'normalizr';
import sharepointSiteSchema from './sharepointSite';
import sharepointRootSchema from './sharepointRoot';

const sharepointSettingsSchema = new schema.Entity('sharepointSettings', {
  sites: new schema.Array(sharepointSiteSchema),
  roots: new schema.Array(sharepointRootSchema),
});

export default sharepointSettingsSchema;
